@if (data.title) {
  <h2 matDialogTitle>
    <span [class.highlight-title]="data.highlightTitle">{{
      data.title | translate
    }}</span>
  </h2>
}
<mat-dialog-content class="mb-3">
  <p class="my-0 mat-body">
    <span
      [innerHTML]="
        data.message.expression | translate: data.message.params
      "></span>
  </p>
  @if (data.additionalMessage) {
    <p
      class="my-0 mt-2 mat-body addiational-info"
      [innerHTML]="
        data.additionalMessage.expression
          | translate: data.additionalMessage.params
      "></p>
  }
</mat-dialog-content>
<mat-dialog-actions fxLayout fxLayoutAlign="end">
  <button mat-button [matDialogClose]="false">
    {{ data.cancelButton | translate }}
  </button>
  @if (!data.options) {
    <button mat-button class="qt-dialog-primary-button" [matDialogClose]="true">
      {{ data.acceptButton | translate }}
    </button>
  } @else {
    @for (option of data.options; track option; let index = $index) {
      <button mat-button [matDialogClose]="index">
        {{ option | translate }}
      </button>
    }
  }
</mat-dialog-actions>
